<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >

    <template #layoutContent>

      <div class="card px-5 pt-3 mb-5">
        <div class="d-flex flex-column flex-md-row justify-content-between">
          <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-3 mb-md-0">
            <li class="nav-item" @click="clickOnTab('col_performance_tab',)">
              <a class="nav-link text-active-primary pb-4" :class="{ 'active' : route.query.tab === 'col_performance_tab' || !route.query.tab }"  data-bs-toggle="tab" href="#col_performance_tab">{{ $t('performance.collaboratorPerfs') }}s</a>
            </li>

            <li class="nav-item" @click="clickOnTab('col_activities')">
              <a class="nav-link text-active-primary pb-4" :class="{ 'active' : route.query.tab === 'col_activities' }"  data-bs-toggle="tab" href="#col_activities">{{ $t('performance.collaboratorActivities') }}</a>
            </li>
          </ul>
          <div class="d-flex justify-content-end mb-5">

          </div>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">
        <div v-if="isActive('col_performance_tab') || !route.query.tab" class="tab-pane fade show" :class="{ 'active': isActive('col_performance_tab') || !route.query.tab }"  id="col_performance_tab" role="tabpanel">
          <CollaboratorPerfs />
        </div>
        <div v-if="isActive('col_activities')"  class="tab-pane fade show" :class="{ 'active': isActive('col_activities') }"  id="col_activities" role="tabpanel">
          <CollaboratorActivities />
        </div>
      </div>

    </template>
  </SubLayout>
</template>

<script setup>

import {computed, ref} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";;
import {useRouter, useRoute} from "vue-router";
import CollaboratorPerfs from "./CollaboratorPerfs.vue";
import CollaboratorActivities from "./CollaboratorActivities.vue";

const router = useRouter()
const route = useRoute()
const store = useStore()

const title = ref("performance.stats")
const breadcrumbs = ref([])


const activeTab = computed(() => route.query.tab || 'col_performance_tab');

const isActive = (tabId) => activeTab.value === tabId;

function clickOnTab(tabId){
  router.replace({ query: { ...route.query, tab: tabId } });
}

</script>

<style scoped>

</style>